import AppTour from 'app/tour/AppTour';
import { TourStepRaw } from 'app/tour/index';

const SpotlightIdStep0 = 'tour-top-actions-menu';
const SpotlightIdStep1 = 'tour-full-screen';

export default class ExternalReportViewerTour extends AppTour {
    static tourName: string = 'external-report-viewer';

    async endTour(): Promise<any> {
        this.spotlight.removeSpotLight(SpotlightIdStep0);
        this.spotlight.removeSpotLight(SpotlightIdStep1);
        return super.endTour();
    }
    async startTour(): Promise<any> {
        this.spotlight.createInterval([
            { spotlightId: SpotlightIdStep0, iconSelector: '#top-actions-menu svg' },
            { spotlightId: SpotlightIdStep1, iconSelector: '#top-full-screen-icon' },
        ]);
        return super.startTour();
    }
    rawSteps: Array<TourStepRaw> = [
        {
            target: `#${SpotlightIdStep0}`,
            content: 'step_0',
            placement: 'bottom-end',
        },
        {
            target: `#${SpotlightIdStep1}`,
            content: 'step_1',
            placement: 'bottom-end',
            waitForSelector: false,
        },
    ];
}
